import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
import CryptoJS from "crypto-js";
import { toast } from 'react-toastify';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, Eye, Phone } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSearch } from '../../SearchContext';
import { useFilter } from '../../FilterContext';
import FilterDrawer from '../FilterDrawer';
import { decryptToken } from '../utils/getToken';

const WalletUserHistory = () => {

    const token = decryptToken("accessToken") || ""
    const encrypted = getDecryptedUserFromCookie("gta_mainstateuser");
    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [customer, setCustomer] = useState([])
    const urlmain = API_BASE_URL
    const navigate = useNavigate()
    const [customers, setCustomers] = useState([
        // Sample data (replace with actual data)
        {
            photo: 'https://via.placeholder.com/50',
            name: 'John Doe',
            attendance: '95%',
            center: 'ABC Institute',
            level: 'Advanced',
            age: 22,
            date: '2023-11-25'
        },
        {
            photo: 'https://via.placeholder.com/50',
            name: 'Jane Smith',
            attendance: '85%',
            center: 'XYZ Academy',
            level: 'Intermediate',
            age: 24,
            date: '2023-11-20'
        },
        {
            photo: 'https://via.placeholder.com/50',
            name: 'Alice Brown',
            attendance: '90%',
            center: 'Tech Solutions',
            level: 'Beginner',
            age: 20,
            date: '2023-11-18'
        },
    ]);
    const [filteredCustomers, setFilteredCustomers] = useState(customers);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const { globalSearch } = useSearch();
    const { entriesPerPage, sortOrder, showDrawer, setShowDrawer, customDate } = useFilter();
    const [load, setLoad] = useState(false);
    const { id, name } = useParams();
    const [dateFilter, setDateFilter] = useState("all");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");


    const fetchDataUser = async () => {
        setLoad(true);
        try {
            const response = await fetch(`${urlmain}/wallet-history/${id}`, {
                method: "GET",
                credentials: "include",
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            });

            const res = await response.json();


            // filter only buy type
            const buyData = res.data?.filter(item => item.type === "buy");

            setCustomer(buyData);
        } catch (error) {
            console.error(error);
        } finally {
            setLoad(false);
        }
    };

    console.log(customer);

    const getDateRange = () => {
        const today = new Date();
        let from = null;
        let to = new Date();

        switch (dateFilter) {
            case "today":
                from = new Date();
                from.setHours(0, 0, 0, 0);
                break;

            case "yesterday":
                from = new Date();
                from.setDate(today.getDate() - 1);
                from.setHours(0, 0, 0, 0);

                to = new Date();
                to.setDate(today.getDate() - 1);
                to.setHours(23, 59, 59, 999);
                break;

            case "7":
            case "14":
            case "28":
            case "60":
            case "90":
                from = new Date();
                from.setDate(today.getDate() - Number(dateFilter));
                break;

            case "custom":
                if (fromDate) {
                    from = new Date(fromDate);
                    from.setHours(0, 0, 0, 0);
                }

                if (toDate) {
                    to = new Date(toDate);
                    to.setHours(23, 59, 59, 999); // 🔥 THIS FIXES IT
                }
                break;


            default:
                return { from: null, to: null };
        }

        return { from, to };
    };



    const toggleActive = async (index, userId) => {
        try {
            const response = await fetch(`${urlmain}/registeruser/toggle-status/${userId}`, {
                method: 'PATCH',
                credentials: "include",
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            });

            const result = await response.json();

            if (!result.isError) {

                const updated = customer.map(cust =>
                    cust.id === userId ? { ...cust, status: result.status } : cust
                );
                toast.success(result.message)
                setCustomer(updated);
            } else {
                toast.error(result.message)
            }
        } catch (error) {
            toast.error(error)
        }
    };


    let filteredUsers = [...customer];

    // APPLY DATE FILTER (our own)
    const { from, to } = getDateRange();

    if (from || to) {
        filteredUsers = filteredUsers.filter(user => {
            const createdAt = new Date(user.createdAt);
            return (!from || createdAt >= from) && (!to || createdAt <= to);
        });
    }

    // 2. Sort by date
    filteredUsers.sort((a, b) => {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
    });

    // 3. Apply global search
    filteredUsers = filteredUsers.filter((user) =>
        Object.values(user).some((value) =>
            String(value).toLowerCase().includes(globalSearch.toLowerCase())
        )
    );

    // 4. Pagination
    const totalPages = Math.ceil(filteredUsers.length / entriesPerPage);
    const currentData = filteredUsers.slice(
        (currentPage - 1) * entriesPerPage,
        currentPage * entriesPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);



    useEffect(() => {
        fetchDataUser();
    }, [])

    if (load) {
        return (
            <div className="loader-wrapper-hbtreal">
                <div className="spinner-hbtreal"></div>
                <p className="loader-text-hbtreal">Loading, Please Wait...</p>
            </div>
        );
    }

    return (
        <>
            <h1 className="dashboard-title">{name} - {id}</h1>
            <div className="wallet-filter-bar">
                <select
                    className="wallet-date-select"
                    value={dateFilter}
                    onChange={(e) => {
                        setDateFilter(e.target.value);
                        setCurrentPage(1);
                    }}
                >
                    <option value="all">All</option>
                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                    <option value="7">Last 7 Days</option>
                    <option value="14">Last 14 Days</option>
                    <option value="28">Last 28 Days</option>
                    <option value="60">Last 60 Days</option>
                    <option value="90">Last 90 Days</option>
                    <option value="custom">Custom Range</option>
                </select>

                {dateFilter === "custom" && (
                    <div className="wallet-custom-date">
                        <input
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                        />
                        <span>—</span>
                        <input
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                        />
                    </div>
                )}
            </div>


            <div className="filter-controls">
                {/* <button onClick={() => setShowDrawer(true)} className="more-filters-btn">
                    <i className="fa-solid fa-sliders"></i> Filters
                </button> */}
            </div>

            {/* Search Filter */}
            {/* <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> 
                    </div>
                </div> */}

            {/* Customer Table */}
            <div className="customer-table responsive-table">
                <table>
                    <thead>
                        <tr>
                            {/* <th>Photo</th> */}
                            <th>Date</th>
                            <th>Amount</th>
                            <th>Total Coin</th>
                            <th>Remark</th>

                        </tr>
                    </thead>
                    <tbody>
                        {currentData.length > 0 ? (
                            currentData.map((customer, index) => (
                                <tr key={index}>
                                    {/* <td>
                                            <img
                                                src={customer.photo}
                                                alt={customer.name}
                                                style={{ width: '50px', height: '50px', borderRadius: '50%' }}
                                            />
                                        </td> */}
                                    <td>{new Date(customer.createdAt).toLocaleString("en-IN", {
                                        timeZone: "Asia/Kolkata",
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true,
                                    })}</td>
                                    <td>{customer.shopping_amount}</td>
                                    <td>{customer.coin}</td>
                                    <td>
                                        {customer.remark}

                                    </td>


                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" style={{ textAlign: 'center' }}>No Users found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="ecom-responsive-cards">
                {currentData.length === 0 ? (
                    <p>No Users Available</p>
                ) : (
                    currentData.map((userRecord, index) => (
                        <div className="ecom-responsive-card"
                            key={index}>

                            <div className="ecom-responsive-header">
                                <p>₹ {userRecord.shopping_amount || "—"}</p>
                                <p>₹ {userRecord.coin}</p>

                            </div>

                            <div className="ecom-responsive-body">
                                <div className="ecom-responsive-left">
                                    <h2>{userRecord.remark || "N/A"}</h2>
                                    <p>{new Date(userRecord.createdAt).toLocaleString("en-IN", {
                                        timeZone: "Asia/Kolkata",
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true,
                                    })}</p>
                                </div>

                                {/* <div className="ecom-responsive-right">
                                    <h4>₹ {userRecord.amount?.toFixed?.(2) || "0.00"}</h4>
                                    {userRecord?.


                                        receipt ? (
                                        <button>
                                            userRecord.receipt.startsWith("https://drive.google.com") ? (
                                            <a href={userRecord.receipt} target="_blank" rel="noopener noreferrer">View receipt</a>
                                            ) : (
                                            <a href={`${url}/Images/userRecord/${userRecord.receipt}`} target="_blank" rel="noopener noreferrer">View receipt</a>
                                            )

                                        </button>
                                    ) : null}
                                </div> */}
                            </div>
                        </div>
                    ))
                )}

            </div>
            {totalPages > 1 && (

                <div className="pagination">
                    {/* First Page */}
                    <button
                        onClick={() => paginate(1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronsLeft size={18} />
                    </button>

                    {/* Previous Page */}
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronLeft size={18} />
                    </button>

                    {/* Current Page Number Only */}
                    <button className="pagination-btn active">
                        {currentPage}
                    </button>

                    {/* Next Page */}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronRight size={18} />
                    </button>

                    {/* Last Page */}
                    <button
                        onClick={() => paginate(totalPages)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronsRight size={18} />
                    </button>
                </div>
            )}
            <FilterDrawer />
        </>
    );
};

export default WalletUserHistory;
